module.exports = __webpack_public_path__ + "img/4.1ca5f038.png";